import React, { memo } from 'react';
import { ModernImageModelNode } from './ModernImageModelNode';
import { NANO_BANANA_2_CONFIG } from './imageModelConfigs';

export { NANO_BANANA_2_CONFIG } from './imageModelConfigs';

export const NanoBanana2Node = memo(props => (
  <ModernImageModelNode {...props} config={NANO_BANANA_2_CONFIG} />
));
